module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_0.23d5a652.png";